import {UnknownStructuredTable} from 'notebook/structured-tables/StructuredTableConstants';
import {SelectionRange} from 'notebook/tables/TableConstants';

/** Returns true if the selected range of a table has any single inputs in it. */
export default function selectionHasSingleInput(
  structuredTable: UnknownStructuredTable,
  selectionRange: SelectionRange | null
): boolean {
  if (!selectionRange) {
    return false;
  }
  const selectedColumns = structuredTable.columns.slice(selectionRange.minIndex, selectionRange.maxIndex + 1);
  return selectedColumns.some((column) => column.isSingleInput);
}
